import { render, staticRenderFns } from "./scoreDetail.vue?vue&type=template&id=4952257d&scoped=true"
import script from "./scoreDetail.vue?vue&type=script&lang=js"
export * from "./scoreDetail.vue?vue&type=script&lang=js"
import style0 from "./scoreDetail.vue?vue&type=style&index=0&id=4952257d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952257d",
  null
  
)

export default component.exports